import request from '../utils/request'

/**
 * 用户管理相关API
 */

// 获取当前用户信息
export function getCurrentUser() {
  return request({
    url: '/user/me',
    method: 'get'
  })
}

// 修改密码
export function changePassword(data) {
  return request({
    url: '/user/change-password',
    method: 'post',
    data
  })
}

// 创建新用户
export function createUser(data) {
  return request({
    url: '/user',
    method: 'post',
    data
  })
}

// 获取用户列表
export function getUserList(params) {
  return request({
    url: '/user/list',
    method: 'get',
    params
  })
}

// 获取单个用户详情
export function getUserDetail(userId) {
  return request({
    url: `/user/${userId}`,
    method: 'get'
  })
}

// 上传头像
export function uploadAvatar(data) {
  return request({
    url: '/user/avatar',
    method: 'post',
    data,
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  })
}

// 获取头像数据
export function getAvatar() {
  return request({
    url: '/user/avatar',
    method: 'get'
  })
}

// 更新用户信息
export function updateUserInfo(data) {
  return request({
    url: '/user/me',
    method: 'put',
    data
  })
}

export default {
  getCurrentUser,
  changePassword,
  createUser,
  getUserList,
  getUserDetail,
  uploadAvatar,
  getAvatar,
  updateUserInfo
}
